import {
  Component,
  ChangeDetectionStrategy,
  model,
  output,
} from '@angular/core';
import { Button } from '@openng/optimus-ui/button';
import { Tooltip } from '@openng/optimus-ui/tooltip';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'ag-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Button, Tooltip, AngularSvgIconModule],
})
export class NotificationComponent {
  readonly visible = model(true);

  readonly dismissed = output();

  dismiss() {
    this.visible.set(false);
    this.dismissed.emit();
  }
}
